import AppBar from './components/AppBar';
import Hero from './components/Hero';
import About from './components/About';
import Research from './components/Research'; // Added Research component
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <AppBar />
      <Hero />
      <About />
      <Research /> {/* Added Research section between About and Projects */}
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;